module.exports = __webpack_public_path__ + "media/images/shapes/blurs/blur-1-bebfff575462f68873f3fb3be538ffc0.svg";